export default __webpack_public_path__ + "static/media/arrow-left.83aa775a.svg";